export default {
  dashboardMetadata: {
    titles: {
      competencies360: 'Competencies 360',
      knowledge: 'Knowledge',
      personalPotential: 'Personal potential',
      conflictLevel: 'The level of conflict',
      managementStyle: 'Management style (Adizes)',
      teamRoles: 'Team roles (Belbin)',
      targets: 'Targets',
      feedbacks: 'Feedbacks',
      proposeRoadmap: 'Initiation of a development plan',
    },
    descriptions: {
      proposeRoadmap: 'Fill in all required fields of the form.',
    },
    formLabels: {
      proposeRoadmapWhy: 'Why do I want a development plan',
      proposeRoadmapSubject: 'What do I want to develop',
      proposeRoadmapResult: 'What result do I want',
      proposeRoadmapDeadline: 'Desired deadline',
    },
    personal: {
      managementStyles: {
        unusual: 'Unusual style',
        lackOfTrends: 'Lack of trends',
        moderate: 'Moderate expression of style',
        vivid: 'Vivid expression of style',
      },
      potential: {},
      teamRoles: {
        preferredRoles: 'Preferred roles',
        unwantedRoles: 'Unwanted roles',
      },
    },
    companyNotSelected:
      'The company is not selected. To display the profile, select the company using the «Change» button',
    welcome: 'Welcome to the HRChain',
    completedAdaptation: 'Shall we complete the adaptation?',
    congratulations: 'Congratulations!',
    newAdaptationPlan: 'A new adaptation plan </br> has been prepared for you',
    adaptationPlanPrepared: 'An adaptation plan has been prepared for you',
    processedDeadlineAdaptation: 'Deadline task: ',
    processedDeadlineTask: 'Deadline adaptation: ',
    adaptationCompleted: 'Adaptation completed',
    goAdaptationButton: 'Start adaptation',
    goPlanButton: 'Go to plan',
    goTasksButton: 'Go to tasks',
    noDeadline: 'none',
    roadmapUntil: 'due',
    tooltips: {
      self: 'Self-assessment - assessments of the user being assessed',
      supervisor: 'Supervisor - user ratings in the role of «Supervisor»',
      experts: 'All without self-assessment',
      proposeRoadmapDisabled:
        "You can't propose a development plan yet: there is no one to approve it and accept the result. You need an assigned supervisor or team leader other than yourself. Contact your company organizer for help.",
    },
    dynamicsOfChanges360: 'Dynamics of changes in the assessment 360',
    defaultPeriodYear: 'Data for the last 12 months',
    noDataPeriod: 'There is no data for the selected period',
    yourFeedback: 'Your feedback feed',
    // messages
    successMessages: {
      changeMetadataUser: 'Profile data has been successfully changed',
      deleteAttachment: 'The attachment successfully deleted',
    },
    errorMessages: {
      getFeedbackData: 'Failed to get feedback data',
      diagramInNotAvailable: 'There is no data on communications',
      getAvailabilityDiagram: "Couldn't check diagram availability",
      getVariantsPersonalReport: 'Failed to get reports variants',
      getLinkPersonalReport: 'Failed to get a link to the report',
      roadmaps: 'Failed to get task board data',
      adaptations: "Failed to get adaptation's tasks data",
      getTargetList: 'Failed to get a target list',
      changeMetadataUser: 'Failed to change profile data',
      changeAvatar: 'Failed to upload avatar',
      changeSpecialization: 'Failed to change specializations',
      deleteAttachment: 'Failed to delete the attachment',
      updateCompany: 'Failed to update company list',
      emailConflict: 'This email is used',
      proposeRoadmap: 'Failed to propose a development plan',
    },
    competenceGroups: {
      emotional: 'Emotional competencies',
      volitional: 'Volitional competencies',
      social: 'Social competencies',
      cognitive: 'Cognitive competencies',
    },
    // confirm dialogs
    confirmGetReport: {
      title: 'Create a report?',
      text: 'Not all test participants filled out the questionnaire, the data obtained may be unreliable.',
      button: 'Yes, create',
    },
    confirmDeleteAttachment: 'Delete the attachment?',
    inQueue: 'in the queue',
    pageDevelopmentPlans: 'Page for working with tasks from development plans',
    new: 'New',
    inProgress: 'In progress',
    done: 'Done',
    overdue: 'Overdue',
    totalTargets: 'total targets',
    efficiency: 'efficiency',
    noData: 'No data on targets',
    sendLink: 'Send',
    sendLinkHint: 'Send mail for password create',
    sendLinkTitle: 'Send mail',
    sendLinkBody: 'Send mail with link to user for password create?',
    successMsg: 'Link sent successfully',
    errorMsg: 'Something went wrong',
  },
};
